var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.5a.833.833 0 0 1-.057-1.116l.057-.063L8.822 10 4.5 5.679a.833.833 0 0 1 1.116-1.236l.063.057 4.32 4.322L14.322 4.5a.833.833 0 0 1 1.236 1.116l-.057.063-4.322 4.32 4.322 4.322a.833.833 0 0 1-1.116 1.236l-.063-.057L10 11.178 5.679 15.5a.833.833 0 0 1-1.179 0z",
    fill: "#8C9299",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnClose);
export default __webpack_public_path__ + "static/media/btn-close.567b35141d4742924b8ce9d9f4374a5f.svg";
export { ForwardRef as ReactComponent };